import React from "react";
import { Paper } from "@material-ui/core";
import { useEffect } from "react";
import { useState, useRef } from "react";
import { useAlert } from "react-alert";
import { Spinner } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import { baseUrl } from "../../../services/config";
import { upperCase } from "lodash";
import { useSelector } from "react-redux";
import { DownloadTableExcel } from "react-export-table-to-excel";

const pageStyle = `
  @page {
      margin-left: 1.5in;
    size: legal landscape !important;
}
`;
const ColumnList = () => {
  const user = useSelector((state) => state.user.user);
  const [campusData, setCampusData] = useState(user.campuses || []);
  const [classesData, setClassesData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [sectionId, setSectionId] = useState("");
  const [campusId, setCampusId] = useState("");
  const [campusName, setCampusName] = useState("");
  const [className, setClassName] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [classId, setClassId] = useState("");
  const [monthName, setMonthName] = useState("");
  const [monthDays, setMonthDays] = useState([]);
  const [monthYear, setMonthYear] = useState("");
  const [studentsData, setStudentsData] = useState(0);
  const [loading, setloading] = useState(false);
  const [fullSession, setFullSession] = useState("");
  const [yearId, setYearId] = useState("");
  const [sessionData, setSessionData] = useState([]);
  const [educationType, setEducationType] = useState(1);
  const [emptyList, setEmptyList] = useState(false);
  //for print
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const exportTable = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  const alert = useAlert();
  let authtoken = localStorage.getItem("userToken");
  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);

  useEffect(() => {
    // getAllCampus();
    sessions();
    getSettingData();
  }, []);

  const sessions = () => {
    fetch(`${baseUrl}/session`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            console.log(session);
            setFullSession(session);
            setYearId(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onChampusChange = (id) => {
    const campus = campusData.find((item) => {
      return item.id == id;
    });

    setCampusName(campus.name);
    setClassName([]);
    setSectionName([]);
    document.getElementById("classselect").selectedIndex = 0;
    document.getElementById("sectionselect").selectedIndex = 0;
    setCampusId(id);
    fetch(`${baseUrl}/campusclass/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.payload) {
          setClassesData(data.payload);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const onClassChange = (id) => {
    document.getElementById("sectionselect").selectedIndex = 0;
    const className = classesData.find((item) => {
      return item.id == id;
    });

    setClassName("  Class:  " + className.name);
    setSectionName([]);
    setClassId(id);
    fetch(`${baseUrl}/class_section/${campusId}/${educationType}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setSectionData(data.payload);
        // getChallans()
      })
      .catch((err) => {
        console.log("", err);
      });
  };
  const getSectionsListOnTypeChange = (id) => {
    fetch(
      `${baseUrl}/class_section/${campusId}/${id}${
        classId ? "/" + classId : ""
      }`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      }
    )
      .then((res) => {
        res.json().then((data) => {
          console.log(data, "section data");
          setSectionData(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getAllStudents = (stucampus, stuclass, stusection) => {
    let data = {
      campus_id: stucampus,
      student_class_id: stuclass,
      global_section_id: stusection,
      education_type: educationType,
      status: 2,
      year_id: yearId,
    };
    setloading(true);

    fetch(`${baseUrl}/student_filter_list`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          let res = data.payload.sort(
            (a, b) => a.admission_id - b.admission_id
          );
          console.log(res);
          setStudentsData(res);
          setloading(false);
          console.log(data.payload);
        })
      )

      .catch((err) => {
        setloading(false);
        console.log(err);
      });
  };

  const onSectionChange = (id) => {
    const sectionName = sectionData.find((item) => {
      return item.id == id;
    });

    setSectionName("  Section:  " + sectionName.name);
    setSectionId(id);
  };
  const handleShow = () => {
    console.log(emptyList);
    if (campusId == "") {
      alert.error("Campus is required ");
      return;
    }
    getAllStudents(campusId, classId, sectionId);
  };

  //for print
  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row">
          <div className="col-md-3">
            <label>
              <b>Select Session</b>
            </label>
            <div className="d-flex flex-column ">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="year_id"
                value={yearId}
                aria-label="Default select example"
                onChange={(e) => {
                  if (e.target.value != "") {
                    const selectedObject = sessionData.find(
                      (option) => option.id == e.target.value
                    );
                    setFullSession(selectedObject);
                  } else {
                    setFullSession("");
                  }
                  setYearId(e.target.value);
                }}
              >
                {sessionData &&
                  sessionData.map((item) => (
                    <option value={item.id}>{item.year}</option>
                  ))}
              </select>
            </div>
          </div>
          <div className="col-md-3">
            <label>
              <b>Select Campus</b>
            </label>
            <div className="d-flex flex-column">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="year_id"
                aria-label="Default select example"
                onChange={(e) => onChampusChange(e.target.value)}
              >
                <option selected value="">
                  Select Campus
                </option>
                {campusData &&
                  campusData.map((item) => (
                    <option value={item.id}>{item.name}</option>
                  ))}
              </select>
            </div>
          </div>
          <div className="col-md-3">
            <label>
              <b>Select Class</b>
            </label>
            <div className="d-flex flex-column">
              <select
                id="classselect"
                style={{ height: 40 }}
                className="form-select"
                name="campus_id"
                aria-label="Default select example"
                onChange={(e) => onClassChange(e.target.value)}
              >
                <option selected value="">
                  Select Class
                </option>
                {classesData &&
                  classesData.map((item) => (
                    <>
                      <option value={item.id}>{item.name}</option>
                    </>
                  ))}
              </select>
            </div>
          </div>
          <div className="col-md-3">
            <label>
              <b>Select Education Type</b>
            </label>
            <select
              className="form-select"
              name="campus_id"
              value={educationType}
              style={{ height: 40 }}
              aria-label="Default select example"
              onChange={(e) => {
                setEducationType(e.target.value);
                getSectionsListOnTypeChange(e.target.value);
              }}
            >
              <option value=""> Select Education Type</option>
              <option selected value={1}>
                Education
              </option>
              <option value={2}>Hifz</option>
            </select>
          </div>
          <div className="col-md-3 mt-3">
            <label>
              <b>Select Section</b>
            </label>
            <div className="d-flex flex-column">
              <select
                id="sectionselect"
                style={{ height: 40 }}
                className="form-select"
                name="campus_id"
                aria-label="Default select example"
                onChange={(e) => onSectionChange(e.target.value)}
              >
                <option selected value="">
                  {" "}
                  Section
                </option>

                {sectionData &&
                  sectionData.map((item) => (
                    <option value={item.id}>{item.name}</option>
                  ))}
              </select>
            </div>
          </div>
          <div style={{ height: 40 }} className="col-md-2 mt-12">
            <input type="checkbox" style={{ display: "none" }} />
            <label className="checkbox checkbox-single mt-4">
              <input
                type="checkbox"
                className="form-checkbox"
                onChange={(e) => setEmptyList(e.target.checked)}
              />
              <span />
              &nbsp;&nbsp;&nbsp;Empty List
            </label>
          </div>
          <div className="col-md-4 mt-12">
            <button className="btn btn-primary" onClick={handleShow}>
              Search
            </button>
            {studentsData?.length > 0 ? (
              <ReactToPrint
                documentTitle={`Attendance Report`}
                onAfterPrint={handleAfterPrint}
                pageStyle={pageStyle}
                onBeforeGetContent={handleOnBeforeGetContent}
                onBeforePrint={handleBeforePrint}
                removeAfterPrint={true}
                trigger={() => (
                  <button
                    // onClick={() => console.log("dfsdfsdfd")}
                    disabled={printloading ? true : false}
                    className="btn btn-primary w-105px mx-2"
                  >
                    {printloading ? <span>Printing..</span> : "Print"}
                  </button>
                )}
                content={() => componentRef.current}
              />
            ) : null}

            <DownloadTableExcel
              filename="Student List - 11 Column"
              sheet="Student List - 11 Column"
              currentTableRef={exportTable.current}
            >
              {studentsData?.length > 0 ? (
                <button className="btn btn-primary mx-2">Export</button>
              ) : null}
            </DownloadTableExcel>
          </div>
        </div>

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner class="text-center" variant="info" animation="border" />
          </div>
        ) : (
          <div>
            {studentsData.length > 0 ? (
              <>
                <div className="row p-3 mt-5">
                  <img
                    // className='col-md-2'
                    style={{ height: 100, width: 110 }}
                    src={icon}
                  />

                  <div className="col-md-8">
                    <h1>{unitName}</h1>
                    <h5>
                      LIST OF STUDENT FOR THE ACADEMIC SESSION{" "}
                      {fullSession.year}
                    </h5>
                    <h6>
                      {campusName} &nbsp; {className} &nbsp; {sectionName}
                    </h6>
                  </div>
                </div>
                <div id="tableboot">
                  <table width={"100%"}>
                    <thead>
                      <tr>
                        <th
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            width: "5%",
                          }}
                        >
                          SrNo.
                        </th>
                        <th
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            width: "10%",
                          }}
                        >
                          Adm-Id
                        </th>
                        <th
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            width: "15%",
                          }}
                        >
                          Student Name
                        </th>
                        <th
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            width: "15%",
                          }}
                        >
                          Father Name
                        </th>
                        {emptyList ? (
                          <td
                            style={{
                              width: "350px",
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {/* Content for includeFee === "true" */}
                            <b> Remarks</b>
                          </td>
                        ) : (
                          [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0].map((day) => (
                            <td
                              key={day}
                              style={{
                                width: "50px",
                                color: "black",
                                border: "1px solid black",
                                textAlign: "center",
                              }}
                            ></td>
                          ))
                        )}
                      </tr>
                    </thead>

                    <tbody>
                      {studentsData.map((item, index) => (
                        <tr id="tbl">
                          <td
                            style={{
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.admission_id}
                          </td>
                          <td
                            style={{
                              width: "235px",
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.name.length > 27
                              ? item.name.slice(0, 27)
                              : item.name}
                          </td>
                          <td
                            style={{
                              width: "235px",
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.father_name.length > 27
                              ? item.father_name.slice(0, 27)
                              : item.father_name}
                          </td>
                          {emptyList ? (
                            <td
                              style={{
                                width: "350px",
                                color: "black",
                                border: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                              {/* Content for includeFee === "true" */}
                            </td>
                          ) : (
                            [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0].map((day) => (
                              <td
                                key={day}
                                style={{
                                  width: "50px",
                                  color: "black",
                                  border: "1px solid black",
                                  textAlign: "center",
                                }}
                              ></td>
                            ))
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : null}
          </div>
        )}

        {/* ///for print */}
        <div
          ref={componentRef}
          id="printSection"
          style={{ visibility: "hidden" }}
          className="tablePrint"
        >
          <div>
            {studentsData.length > 0 ? (
              <>
                <div className="p-3" style={{ display: "flex" }}>
                  <img
                    // className='col-md-2'
                    style={{ height: 110, width: 110 }}
                    src={icon}
                  />

                  <div className="col-md-8">
                    <h1>{unitName}</h1>
                    <h5>
                      LIST OF STUDENT FOR THE ACADEMIC SESSION{" "}
                      {fullSession.year}
                    </h5>
                    <h6>
                      {campusName} &nbsp; {className} &nbsp; {sectionName}
                    </h6>
                  </div>
                </div>
                <div id="tableboot">
                  <table>
                    <thead>
                      <tr>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          Sr
                        </td>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Adm-Id
                        </td>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Student Name
                        </td>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Father Name
                        </td>
                        {emptyList ? (
                          <td
                            style={{
                              width: "650px",
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {/* Content for includeFee === "true" */}
                            Remarks
                          </td>
                        ) : (
                          [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0].map((day) => (
                            <td
                              key={day}
                              style={{
                                width: "60px",
                                color: "black",
                                border: "1px solid black",
                                textAlign: "center",
                              }}
                            ></td>
                          ))
                        )}
                      </tr>
                    </thead>

                    <tbody>
                      {studentsData.map((item, index) => (
                        <tr id="tbl">
                          <td
                            style={{
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.admission_id}
                          </td>
                          <td
                            style={{
                              color: "black",
                              width: "255px",
                              border: "1px solid black",
                              textAlign: "left",
                              paddingLeft: "3px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.name.length > 27
                              ? item.name.slice(0, 27)
                              : item.name}
                          </td>
                          <td
                            style={{
                              color: "black",
                              width: "255px",
                              border: "1px solid black",
                              textAlign: "left",
                              paddingLeft: "3px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.father_name.length > 27
                              ? item.father_name.slice(0, 27)
                              : item.father_name}
                          </td>
                          {emptyList ? (
                            <td
                              style={{
                                width: "650px",
                                color: "black",
                                border: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                              {/* Content for includeFee === "true" */}
                            </td>
                          ) : (
                            [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0].map((day) => (
                              <td
                                key={day}
                                style={{
                                  width: "60px",
                                  color: "black",
                                  border: "1px solid black",
                                  textAlign: "center",
                                }}
                              ></td>
                            ))
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : null}
          </div>
        </div>

        {/* ///for exprot print */}
        <div
          ref={exportTable}
          id="printSection"
          style={{ visibility: "hidden" }}
          className="tablePrint"
        >
          <div>
            {studentsData.length > 0 ? (
              <>
                <div className="p-3" style={{ display: "flex" }}>
                  <img
                    // className='col-md-2'
                    style={{ height: 110, width: 110 }}
                    src={icon}
                  />

                  <div className="col-md-8">
                    <h1>{unitName}</h1>
                    <h5>
                      LIST OF STUDENT FOR THE ACADEMIC SESSION{" "}
                      {fullSession.year}
                    </h5>
                    <h6>
                      {campusName} &nbsp; {className} &nbsp; {sectionName}
                    </h6>
                  </div>
                </div>
                <div id="tableboot">
                  <table>
                    <thead>
                      <tr>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          Sr
                        </td>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Adm-Id
                        </td>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Student Name
                        </td>
                        <td
                          style={{
                            color: "black",
                            border: "1px solid black",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Father Name
                        </td>
                        {emptyList ? (
                          <td
                            style={{
                              width: "650px",
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {/* Content for includeFee === "true" */}
                            Remarks
                          </td>
                        ) : (
                          [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0].map((day) => (
                            <td
                              key={day}
                              style={{
                                width: "60px",
                                color: "black",
                                border: "1px solid black",
                                textAlign: "center",
                              }}
                            ></td>
                          ))
                        )}
                      </tr>
                    </thead>

                    <tbody>
                      {studentsData.map((item, index) => (
                        <tr id="tbl">
                          <td
                            style={{
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              color: "black",
                              border: "1px solid black",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.admission_id}
                          </td>
                          <td
                            style={{
                              color: "black",
                              width: "255px",
                              border: "1px solid black",
                              textAlign: "left",
                              paddingLeft: "3px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.name.length > 27
                              ? item.name.slice(0, 27)
                              : item.name}
                          </td>
                          <td
                            style={{
                              color: "black",
                              width: "255px",
                              border: "1px solid black",
                              textAlign: "left",
                              paddingLeft: "3px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.father_name.length > 27
                              ? item.father_name.slice(0, 27)
                              : item.father_name}
                          </td>
                          {emptyList ? (
                            <td
                              style={{
                                width: "650px",
                                color: "black",
                                border: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                              {/* Content for includeFee === "true" */}
                            </td>
                          ) : (
                            [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0].map((day) => (
                              <td
                                key={day}
                                style={{
                                  width: "60px",
                                  color: "black",
                                  border: "1px solid black",
                                  textAlign: "center",
                                }}
                              ></td>
                            ))
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </Paper>
    </>
  );
};

export default ColumnList;
